var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 8.9917C13.1642 8.9917 13.5 9.32749 13.5 9.7417V12.6087C13.5 12.6675 13.5256 12.7849 13.6025 12.9199C13.6796 13.0549 13.7675 13.1365 13.8176 13.1663L13.8196 13.1674L13.8196 13.1675L15.9874 14.4611C16.3431 14.6734 16.4593 15.1338 16.2471 15.4895C16.0348 15.8452 15.5744 15.9614 15.2187 15.7492L13.0529 14.4567C13.0526 14.4565 13.0522 14.4563 13.0519 14.4561C12.7249 14.262 12.4706 13.9629 12.2995 13.6629C12.1283 13.3626 12 12.9905 12 12.6087V9.7417C12 9.32749 12.3358 8.9917 12.75 8.9917Z",
    fill: "#1F2328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7699 21.6436C12.0035 23.7224 6.44436 21.5321 4.36955 16.7749C3.62197 15.0608 3.40253 13.1819 3.73216 11.3362C3.80706 10.9326 4.19789 10.6531 4.60149 10.728C5.00509 10.8029 5.28464 11.1937 5.20974 11.5973C4.93199 13.1367 5.122 14.723 5.74964 16.1621C7.49664 20.1677 12.1698 22.0025 16.1754 20.2555C20.181 18.5085 22.0158 13.8353 20.2688 9.82971C18.5218 5.8241 13.8395 3.99331 9.83387 5.74031C8.99058 6.1081 8.2176 6.58705 7.54242 7.16518C7.22375 7.43508 6.75082 7.40133 6.48092 7.08266C6.21101 6.76398 6.24476 6.29106 6.56344 6.02115C7.36012 5.3464 8.24944 4.78398 9.23021 4.35622C13.9966 2.27741 19.5558 4.46765 21.6306 9.22488C23.7054 13.9821 21.5363 19.5648 16.7699 21.6436Z",
    fill: "#1F2328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.31624 8.00544C6.16042 8.0734 5.97144 8.09037 5.79514 8.03634C5.38989 7.90762 5.1745 7.4888 5.29805 7.09671L6.61983 2.89821C6.74339 2.50612 7.16737 2.27757 7.56346 2.41029C7.95555 2.53385 8.17493 2.96183 8.05138 3.35392L6.72561 7.54325C6.65607 7.75904 6.49956 7.92549 6.31624 8.00544Z",
    fill: "#1F2328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.3883 8.91308C10.2508 8.97305 10.0842 8.99118 9.92906 8.96066L5.84346 8.04785C5.44503 7.95978 5.19298 7.55696 5.28104 7.15853C5.36511 6.75094 5.76793 6.49888 6.17552 6.58294L10.248 7.49059C10.6464 7.57865 10.9076 7.97748 10.8144 8.38907C10.77 8.63753 10.5992 8.82114 10.3883 8.91308Z",
    fill: "#1F2328"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.af134e6b0c54073f84028f4464128931.svg";
export { ForwardRef as ReactComponent };